import { Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
// import { useLocation, useParams } from "react-router";
import { useNavigate } from "react-router";
import { useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import style from "../assets/css/page/AddPlayer.module.css";
import Button from "../components/Button/Button";
import CardPlayer from "../components/Card/CardPlayer";
import Header from "../components/Header/Header";
import Input from "../components/Input/Input";
import InputSelect from "../components/Input/InputSelect";
import Loading from "../components/Loading";
import useAddPlayer from "../hooks/useAddPlayer";
import { GET_TOURNAMENTS } from "../graphql/queries";

import {
  AddPlayerInitialState,
  AddPlayerValidationSchema,
} from "../utils/player";
import { useQuery } from "@apollo/client";

import { socket } from "../config/socket";

const MySwal = withReactContent(Swal);

const positionOption = [
  { value: "portero", label: "portero" },
  { value: "defensa", label: "defensa" },
  { value: "medio", label: "medio" },
  { value: "delantero", label: "delantero" },
];

function AddPlayer() {
  const location = useLocation();
  const navigate = useNavigate();
  const role = window.localStorage.getItem("role");
  const { loading, addPlayer } = useAddPlayer();
  const tournaments = useQuery(GET_TOURNAMENTS);
  const teamLogin = JSON.parse(window.localStorage.getItem("team"));
  const [totalPlayers, setTotalPlayers] = useState(0);
  const [numRegPlayer, setNumRegPlayer] = useState(0);

  useEffect(() => {
    if (role === "Public" || role === null) {
      navigate("/");
    }
  }, [role]);

  useEffect(() => {
    // setLoading(true);
    let idTeam = teamLogin?.id;

    if (idTeam) {
      socket.emit("totalPlayer", { idTeam }, (res) => {
        setTotalPlayers(res);
      });
      socket.emit("getNumRegisterPlayer", { idTeam }, (res) => {
        setNumRegPlayer(res);
      });
    }
  }, []);

  console.log(numRegPlayer);

  const handleSubmit = async (values) => {
    values = {
      ...values,
      team: location.state?.idTeam,
      dayRegister: tournaments?.data?.tournaments[0]?.currentDay,
    };
    const response = await addPlayer(values);

    if (response) {
      const { team, dayRegister } = values;
      console.log("dayRegister", dayRegister);

      socket.emit("lessNumRegisterPlayer", { team }, (res) => {
        MySwal.fire("Registrado Exitosamente").then((result) => {
          if (result.isConfirmed) {
            window.location.reload();
          }
        });
      });
    }
  };

  if (loading || tournaments.loading) return <Loading />;

  return (
    <div className={style.container}>
      <Header
        nameTeam={location.state?.nameTeam}
        teamColor={location.state?.color}
        tournament={tournaments.data.tournaments[0].name}
      />
      {tournaments.data.tournaments[0].registerPlayers && totalPlayers < 15 && numRegPlayer > 0 ? (
        <Formik
          initialValues={AddPlayerInitialState}
          validationSchema={AddPlayerValidationSchema}
          onSubmit={handleSubmit}
        >
          {({ errors, handleChange, touched, values }) => (
            <div className={style.register}>
              <div className={style.player}>
                <div className={style.cardPlayer}>
                  <CardPlayer
                    teamColor={location.state?.color}
                    name={values.name}
                    app={values.app}
                    position={values.position}
                    numShirt={values.numShirt}
                  />
                </div>
              </div>
              <Form className={style.form}>
                <div className={style.contInputs}>
                  <Input name="name" title="Nombre" type="text" />
                  <Input name="app" title="Apellido paterno" type="text" />
                  <Input name="apm" title="Apellido materno" type="text" />
                  <Input
                    name="numShirt"
                    title="Número de camiseta"
                    type="number"
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value >= 1 && value <= 100) handleChange(e);
                      if (value < 1) handleChange(e);
                    }}
                  />
                  <InputSelect
                    error={touched.position && errors.position}
                    name="position"
                    title="Posición"
                    options={positionOption}
                    onChange={(selectedOption) => {
                      handleChange("position")(selectedOption.value);
                    }}
                  />
                </div>
                <div className={style.contButton}>
                  <Button text="Guardar" />
                </div>
              </Form>
            </div>
          )}
        </Formik>
      ) : (
        <div className={style.contMessage}>
          <p className={style.text}>Registro de jugadores terminado</p>
        </div>
      )}
    </div>
  );
}

export default AddPlayer;
